module.exports = __webpack_public_path__ + "img/logo-isia.a9305875.png";